import React from "react";

import _str from "shared/util/_str";
import getImagePath from "shared/util/getImagePath";

const OkcLoader = () => (
	<img
		style={{ width: 88 }}
		src={`${getImagePath()}/media/img/loaders/okc.gif`}
		alt={_str("Please wait...")}
	/>
);

export default OkcLoader;



// WEBPACK FOOTER //
// ./src/shared/components/OkcLoader/index.jsx